import MTextField from './MTextField.vue';

export { MTextField };
export default MTextField;
